import React from 'react';
import { SvgProps } from '../icon.types';

function WindBoldIcon({ fillColor = '#2D3049' }: SvgProps) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg">
      <defs />
      <path
        d="M15 15l.1762873.0050922C16.7512156 15.0963291 18 16.4021786 18 18c0 1.657-1.343 3-3 3s-3-1.343-3-3h2c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1H2v-2h13zm3-10c2.209 0 4 1.79 4 4 0 2.209-1.791 4-4 4H2v-2h16c1.103 0 2-.897 2-2 0-1.104-.897-2-2-2s-2 .896-2 2h-2c0-2.21 1.791-4 4-4zm-8-2c1.657 0 3 1.343 3 3s-1.343 3-3 3H2V7h8c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1H7c0-1.657 1.343-3 3-3z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { WindBoldIcon };
